<template>
  <div class="rounded-lg shadow-lg mx-60">
    <div
      v-if="isLoading">
      <div class="bg-gray-200 rounded-lg p-8 font-bold text-lg">Loading...</div>
    </div>

    <div
      v-if="hasError">
      <h2 class="text-xl font-bold mb-4">Oops!</h2>
      <div class="text-md font-semibold">Something went wrong</div>
      <div class="bg-gray-200 p-2 rounded-md">
        <div class="bg-red-200 p-2 rounded-md">
          <span>{{ error }}</span>
        </div>
      </div>
    </div>

    <div class="relative p-2 rounded-lg bg-white"
      v-if="showMainSection">
      <div class="flex flex-col items-center gap-6">
        <h1 class="text-4xl font-bold m-4">CST Portal</h1>

        <div class="flex flex-col items-center rounded-lg bg-gray-200 shadow-md"
          v-if="!isLoggedIn">
          <div class="p-2">Get started by signing in to your account</div>
          <Button
            class="p-2 mb-2 rounded-sm"
            color="blue"
            @click="login">
            Log In
          </Button>
        </div>

        <div class="flex flex-col"
          v-if="showProfile">
          <div class="rounded-lg p-2 bg-gray-200 shadow-md">
            <div class="flex flex-col items-center gap-1 pt-2"
              v-if="user !== undefined">
              <img
                :src="imageSrc"
                :alt="imageAlt"
                style="
                  width: 110px;
                  height: 110px;
                  border-radius: 50%;
                  object-fit: cover;
                  border: 3px solid #63b3ed;
                "
              />
              <div class="text-center">
                <div class="text-md font-semibold text-gray-600 m-2">
                  {{ user.name }}
                </div>
                <div class="text-small">
                  {{ displayUserEmail }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col w-full"
          v-if="confirmLogout">
          <div class="flex m-2 gap-2 justify-end">
            <Button
              color="gray"
              class="font-medium rounded-sm text-gray-900 bg-gray-100 px-3 py-2 hover:bg-gray-200 transition-colors shadow-sm"
              @click="closePrompt">
              Close
            </Button>
            <Button
              color="blue"
              class="px-3 py-2 rounded-sm"
              @click="logout">
              Confirm Log Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { default as auth0User } from '../../services/auth0/user.js'

import Button from '../Button.vue'

export default {
  components: {
    Button,
  },
  data() {
    return {
      isLoading: true,
      hasError: false,
      showMainSection: false,
      isLoggedIn: false,

      showProfile: false,
      confirmLogout: true,

      user: undefined,
    }
  },
  mounted() {
    this.showLoading()
    auth0User.get().then(() => {
      this.updateUI()
    })
  },
  methods: {
    async login() {
      try {
        await auth0User.loginWithRedirect()
        await this.updateUI()
      }
      catch (err) {
        this.showError(err.message)
      }
    },
    async logout() {
      try {
        await auth0User.logout()
      }
      catch (err) {
        this.showError(err.message)
      }
    },
    async updateUI() {
      try {
        const isAuthenticated = await auth0User.isAuthenticated()
        if (isAuthenticated) {
          this.showLoggedIn()
          this.user = await auth0User.getUser()
          this.hideLoading()
        }
        else {
          setTimeout(() => {
            auth0User.loginWithRedirect()
          }, 2000)
        }
      }
      catch (err) {
        this.hideLoading()
        this.showError(err.message)
      }
    },
    showLoggedIn() {
      this.isLoggedIn = true
    },
    showLoggedOut() {
      this.isLoggedIn = false
    },
    showLoading() {
      this.isLoading = true
      this.showMainSection = false
    },
    hideLoading() {
      this.isLoading = false
      this.showMainSection = true
    },
    showError(message) {
      this.hasError = true
      this.error = message
    },
    closePrompt() {
      this.$emit('closePrompt')
    }
  },
  computed: {
    imageSrc() {
      return this.user
        ? this.user.picture
        : auth0User.getPlaceholderImage()
    },
    imageAlt() {
      return this.user
        ? this.user.name
        : 'User'
    },
    displayUserEmail() {
      if (!this.user) {
        return ''
      }
      return this.user.email
        ? this.user.email
        : 'No Email Provided'
    }
  }
}
</script>
